import { MultiOptionField, SingleField } from 'components/ModalInfo.Fields';
import { useAppSelector } from 'hooks';
import * as React from 'react';
import { selectadFormatsAsOptions } from 'store/adformats';
import { useTranslation } from 'react-i18next';

const ProductAdFormatInfo = ({
  value,
  gridColumn,
  ...props
}: {
  value: number[];
  gridColumn: any;
  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  const adFormats = useAppSelector(selectadFormatsAsOptions);

  if (typeof value === 'undefined' || value.length === 0) {
    return (
      <SingleField
        header={t('adFormat_other', 'Formaty reklamowe')}
        value='Brak'
        gridColumn={gridColumn}
        {...props}
      />
    );
  }

  const elements = adFormats
    .filter(({ id }: { id: number }) => value.includes(id))
    .map(({ name }: { name: string }) => name);

  return (
    <MultiOptionField
      header={t('adFormat_other', 'Formaty reklamowe')}
      elements={elements}
      gridColumn={gridColumn}
      {...props}
    />
  );
};

ProductAdFormatInfo.displayName = 'Product.adFormatInfo';

export { ProductAdFormatInfo };
